export default __webpack_public_path__ + "static/media/image-builder.dbb2812f.jpg";